import React from 'react';

import { connect } from 'react-redux';
import { reduxForm, reset } from 'redux-form';

import * as API from '../../core/api';
import { catchFormErrors } from '../../utils/form-errors';
import { requestDataIfNeeded, addGoal } from '../../user/duck';

import Form from './Form';
const ReduxForm = reduxForm({ form: 'goal-create' })(Form);

class Create extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shouldDisplayMenu: false,
    };
  }

  handleSubmit = (formValues) => {
    const { onSuccess } = this.props;

    return API.post('goals', {
      ...formValues,
      status: formValues.status ? 'COMPLETED' : 'UNCOMPLETED',
    })
      .then(this.props.addGoal)
      .then(() => this.props.reset('goal-create'))
      .then(onSuccess)
      .catch(catchFormErrors);
  };

  handleFocus = (value) => {
    this.setState({
      shouldDisplayMenu: true,
    });
  };

  handleCancel = () => {
    const { onCancel } = this.props;

    this.setState({ shouldDisplayMenu: false });
    onCancel();
  };

  render() {
    const { autoFocus } = this.props;
    const { shouldDisplayMenu } = this.state;

    return (
      <ReduxForm
        autoFocus={autoFocus}
        onSubmit={this.handleSubmit}
        enableDelete={false}
        shouldDisplayMenu={shouldDisplayMenu}
        onFocus={this.handleFocus}
        onCancel={this.handleCancel}
      />
    );
  }
}

Create.defaultProps = {
  onCancel: () => {},
};

const mapDispatchToProps = {
  requestUserDataIfNeeded: requestDataIfNeeded,
  reset,
  addGoal,
};
export default connect(
  null,
  mapDispatchToProps
)(Create);



// WEBPACK FOOTER //
// ./src/goals/create/index.js